// extracted by mini-css-extract-plugin
export default {"main":"Bookmarks_main__z5R0A","loadingState":"Bookmarks_loadingState__8d6ZX","list":"Bookmarks_list__VIV3w"};